'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CatalogueResultItemAlert = require('./components/CatalogueResultItemAlert.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CatalogueResultItemAlert).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/add-title/lib/components/catalogue-result-item-alert/index.js
// module id = 976
// module chunks = 1